import $ from 'jquery'

// Show the cost center of the Notice::Kind picked in the new Notice view.
// The location and the recipient cascade through cascade-select.js.
// ---------------------------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  const selectNoticeKind = $('#notice_notice_kind_id')
  if (!selectNoticeKind.length) return // Not on the new notice page

  const costCenterNames = $('#notice_notice_kind_cost_center').data('idcostcenters')

  // Change value of disabled cost_center_showonly text input or enable cost_center input field, if selected Notice::Kind has no cost_center set
  const setNoticeKindCostCenter = () => {
    const noticeKindId = selectNoticeKind.find(':selected').val()
    const costCenterName = costCenterNames?.[noticeKindId]
    if (costCenterName) {
      $('#cost_center_showonly').show()
      $('#notice_cost_center').hide()
      // Set disabled text field
      $('#cost_center_showonly').val(costCenterName)
      // Set hidden field
      $('#notice_cost_center').val(costCenterName)
    } else {
      if (selectNoticeKind.val() === '') { // Nothing selected yet
        $('#cost_center_showonly').show()
        $('#notice_cost_center').hide()
      } else {
        $('#cost_center_showonly').hide()
        $('#notice_cost_center').show()
      }
      // Clear that stuff
      $('#cost_center_showonly').val('')
      const formResubmitValue = $('#notice_cost_center').data('form-resubmit-cost-center') // Get user selected value after form validation has failed
      $('#notice_cost_center').val(formResubmitValue)
    }
  }

  // Populate cost_center
  selectNoticeKind.off('change.noticeKindCostCenter').on('change.noticeKindCostCenter', setNoticeKindCostCenter)

  // Also after page (re)load, e.g. validation fail
  setNoticeKindCostCenter()
})

// Disable save button on Notice rating form until all ratings are selected
// ---------------------------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  $('form.rate_notice button[type="submit"]').prop('disabled', true)
  $('form.rate_notice input[type="radio"]').off('change.noticeRating').on('change.noticeRating', () => {
    if ($('form.rate_notice input[type="radio"]:checked').length === $('form.rate_notice .rating.form').length) {
      $('form.rate_notice button[type="submit"]').prop('disabled', false)
    } else {
      $('form.rate_notice button[type="submit"]').prop('disabled', true)
    }
  })
})

// Show rating when state_change accept is selected
// ------------------------------------------------

$(document).on('turbo:load turbo:render', () => {
  $('#notice_message_state_change').off('change.noticeMessageState').on('change.noticeMessageState', function() {
    if ($(this).val() === 'accept') {
      $('.rate_notice_fields').show()
    } else {
      $('.rate_notice_fields').hide()
    }
  })
})
